const CalendarEditSteps = {
    EVENTS: { value: "events" },
    CUSTOMIZE: { value: "customize" },
    PROOF: { value: "proof" },
    THEME: { value: "theme" },
    PLACE_ORDER: { value: "place order" },
};

export default CalendarEditSteps;
